<script>
import {
  DatePicker,
  TimeSelect,
  Table,
  TableColumn,
  Select,
  Option,
} from "element-ui";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
  },
  data() {
    return {
      template_name: "",
      template_type: "",
      template_code: "",
      stripo_template_id: "",  // New field for Stripo Template ID
      emailTemplates: [
        { value: 'marketing', label: 'Marketing' },
        { value: 'automation', label: 'Automation' },
      ],
      selectedTemplate: null,
      loading: false,
      temp_id: "",
      promocode: {
        promo_code: "",
        description: "",
        percentage: "",
        valid_upto: "",
        status: true,
      },
      errors: {
        promo_code: "",
        percentage: "",
        valid_upto: "",
      },
      temp_id: this.$route.query.id || "",  // Ensure temp_id is initialized
    };
  },
  created() {
    if (this.temp_id) {
      this.fetchTemplate(); // Fetch template if it's an edit (temp_id exists)
    }
  },
  methods: {
    fetchTemplate() {
      this.loading = true; // Show loading spinner

      this.$http
        .get(`/edit-email-template/${this.temp_id}`)  // Make the API request to fetch template by ID
        .then((response) => {
          if (response.data.success) {
            const template = response.data.data;
            this.template_name = template.template_name;
            this.template_type = template.template_type;
            this.template_code = template.template_code;
            this.stripo_template_id = template.stripo_template_id || "";  // Populate the new field
          } else {
            Swal.fire({
              title: "Error",
              text: response.data.message,
              icon: "error",
            });
          }
        })
        .finally(() => {
          this.loading = false; // Hide loading spinner
        });
    },
    saveTemplate() {
      if (this.temp_id !== "") {
        this.loading = true;
        const templateData = {
          template_name: this.template_name,
          template_type: this.template_type,
          ...(this.template_type === 'automation' && { template_code: this.template_code }),
          stripo_template_id: this.stripo_template_id,  // Include new field on update
        };

        // Use PUT request for updating
        const id = this.$route.query.id;  // Get the template ID from query params
        this.$http
          .put(`/update-email-template/${id}`, templateData)
          .then((response) => {
            Swal.fire({
              title: "Success",
              text: "Template updated successfully.",
              icon: "success",
            });
            this.$router.push("/email_template");  // Redirect after success
          })
          .catch((error) => {
            if (error.response && error.response.data.errors) {
              const errorMessages = Object.values(error.response.data.errors)
                .flat()
                .join("\n");

              Swal.fire({
                title: "Validation Error",
                text: errorMessages,
                icon: "error",
              });
            } else {
              Swal.fire({
                title: "Error",
                text: "An unexpected error occurred.",
                icon: "error",
              });
            }
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.loading = true;
        const data = {
          template_name: this.template_name,
          template_type: this.template_type,
          ...(this.template_type === 'automation' && { template_code: this.template_code }),
          stripo_template_id: this.stripo_template_id,  // Include new field on create
        };
        this.$http
          .post("/save-email-template", { data })
          .then((resp) => {
            if (resp.data.success) {
              Swal.fire({
                title: "Success!",
                text: resp.data.message || "Email template saved successfully.",
                icon: "success",
              });
              this.$router.push("/email_template"); // Adjust route as necessary
            } else {
              Swal.fire({
                title: "Error!",
                text: "An unexpected error occurred. Please try again.",
                icon: "error",
              });
            }
          })
          .catch((error) => {
            if (error.response && error.response.data.errors) {
              const errorMessages = Object.values(error.response.data.errors)
                .flat() // Flatten nested arrays of messages
                .map((msg, index) => `${index + 1}. ${msg}`) // Add numbering
                .join('\n'); // Join messages with a new line

              Swal.fire({
                title: "Validation Error",
                text: errorMessages,
                icon: "error",
              });
            } else if (error.response && error.response.data.message) {
              Swal.fire({
                title: "Error",
                text: error.response.data.message,
                icon: "error",
              });
            } else {
              Swal.fire({
                title: "Error",
                text: "An unexpected error occurred. Please try again.",
                icon: "error",
              });
            }

            console.error('Errors:', error);
          })
          .finally(() => {
            this.loading = false; // Ensure loading is turned off
          });
      }

    },
  },
};
</script>
<template>
  <div class="content" v-loading.fullscreen.lock="loading">
    <base-header class="pb-6">
      <div class="row align-items-center py-2">
        <div class="col-lg-6 col-7"></div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <card>
        <h2 slot="header" class="mb-0" v-if="temp_id">Edit Email Template</h2>
        <h2 slot="header" class="mb-0" v-else>Add Email Template</h2>
        <form @submit.prevent="saveTemplate()" enctype="multipart/form-data">
          <div class="form-row">
            <div class="col-md-8">
              <label class="form-control-label">Template Name <span class="requireField">*</span></label>
              <base-input name="Template Name" placeholder="Template Name" v-model="template_name"></base-input>
            </div>

            <div class="col-md-8">
              <label class="form-control-label">Template Type <span class="requireField">*</span></label>
              <base-input>
                <el-select filterable placeholder="Select Template" v-model="template_type">
                  <el-option v-for="option in emailTemplates" :key="option.value" :value="option.value" :label="option.label">
                  </el-option>
                </el-select>
              </base-input>
            </div>

            <div class="col-md-8" v-if="template_type === 'automation'">
              <label class="form-control-label">Template Code <span class="requireField">*</span></label>
              <base-input type="text" name="Template Code" placeholder="Template Code" v-model="template_code"></base-input>
            </div>

            <!-- Added Stripo Template ID field -->
            <div class="col-md-8">
              <label class="form-control-label">Stripo Template ID</label>
              <base-input name="Stripo Template ID" placeholder="Enter Stripo Template ID" v-model="stripo_template_id"></base-input>
            </div>
          </div>
          <div class="text-left mt-2">
            <base-button class="btn greybtn" type="danger" @click="$router.go(-1)">Cancel</base-button>
            <base-button class="btn btn-primary" type="primary" native-type="submit">{{ temp_id !== "" ? " Update" : "Submit" }}</base-button>
          </div>
        </form>
      </card>
    </div>
  </div>
</template>

<style></style>
